<template>
  <Loading v-if="showLoading" />
  <router-view v-else />
  <DDynamicDialog class="bg-surface-800" />
  <DConfirmDialog />
  <Toast />
</template>

<script setup>
import Toast from '@/components/misc/Toast.vue';
import { useAppStore } from '@/stores/appStore';
import { useUserStore } from '@/stores/userStore';
import Loading from '@/views/Loading.vue';
import { DConfirmDialog, DDynamicDialog } from '@disguise/cloud-ui';
import { computed } from 'vue';

const userStore = useUserStore();
const appStore = useAppStore();

const showLoading = computed(() => {
  if (userStore.isLoading && !userStore.isAuthenticated) return true;
  if (appStore.pageLoading) return true;
  return false;
});
</script>
